const messages = {
  title: "Bonusový multiplikátor",
  bandBonusTitle: "Bonus na pneumatiku při multiplikátoru",
  amountLabel: "Min. počet pneumatik (*)",
  label: "Bonusový multiplikátor",
  desc: "Počet pneumatik Bridgestone a Firestone. Za pneumatiky Firestone není bonus v eurech.",
  goals: {
    loyal: "Věrný",
    bronze: "Bronz",
    silver: "Stříbro",
    gold: "Zlato",
    platinum: "Platina",
  },
  andMore: "a více",
  chooseTarget: "Vybrat",
  selectTarget: "Zvolte zde svůj roční cíl pro {year}:",
  multiplication: "Bonus se násobí <b>{factor}</b>",
  minTyres: "<b>Minimum:</b> {tyre} pneumatik",
};

export default {
  messages,
};
